import { SheetsImportCtrl } from './sheets.import.controller';

routesConfig.$inject = ['$stateProvider'];

export function routesConfig($stateProvider) {
  $stateProvider
    .state('sheets', {
      url: '/sheets',
      template: '<ui-view/>',
    })
    .state('sheets.import', {
      url: '/import/:type/:id',
      controller: SheetsImportCtrl,
      controllerAs: 'vm',
      template: require('../sheets.import/sheets.step1.html'),
    })
    .state('sheets.import.step2', {
      url: '/:tableId',
      template: require('../sheets.import/sheets.step2.html'),
    });
}
